namespace appn.views.tasks.review {

    export function init(): void {
        addEvents();
    }

    function addEvents() {
        // Click event handler for viewing media files
        $('td').on('click', 'a#viewMedia', function(event) {
            event.preventDefault();
            appn.dialog.viewMediaFromElement($(this));
        });
    }
}
